import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Lenis from "lenis";

import { Nav } from "@/components/landing/Nav";
import { Hero } from "@/components/landing/Hero";
import { Ribbon } from "@/components/landing/Ribbon";
import { FeaturedFilms } from "@/components/landing/FeaturedFilms";
import { Categories } from "@/components/landing/Categories";
import { HowItWorks } from "@/components/landing/HowItWorks";
import { Pricing } from "@/components/landing/Pricing";
import { Footer } from "@/components/landing/Footer";

export default function Landing() {
  const navigate = useNavigate();
  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.15,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
    });
    window.__lenis = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  const scrollToPricing = () =>
    document.querySelector("#pricing")?.scrollIntoView({ behavior: "smooth" });
  const goArchive = () => navigate("/archive");

  return (
    <>
      <Nav onEnter={scrollToPricing} onArchive={goArchive} />
      <main>
        <Hero onEnter={scrollToPricing} onBrowse={goArchive} />
        <Ribbon />
        <FeaturedFilms />
        <Categories />
        <HowItWorks />
        <Pricing />
      </main>
      <Footer onEnter={scrollToPricing} />
    </>
  );
}
